module.exports = __webpack_public_path__ + "static/microsoft_dynamic-48fa1a16883c302c7771d559abf55fa1.png";